// app/javascript/controllers/greet_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
  }

  disconnect() {
  }

  sayHello = (e) => {
    e.preventDefault()
    alert("👋 Hello from Stimulus!")
  }
}